import * as React from 'react'
import Box from '@mui/material/Box'
import type { MuiErrorState } from './typings'
import { useDateRangeInput } from './useDateRangeInput'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

export function DateRangePicker() {
  const tidalThemeActive = useTidalThemeActive()

  const [muiErrors, setMuiErrors] = React.useState<MuiErrorState>(() => ({}))
  const { getFormat } = useLocalizationDateFormat()

  const startField = useDateRangeInput({
    field: 'start',
    muiErrors,
    setMuiErrors,
  })

  const endField = useDateRangeInput({
    field: 'end',
    muiErrors,
    setMuiErrors,
  })

  return (
    <Box display="flex">
      <DatePicker
        label="From"
        disablePast
        format={getFormat()}
        {...startField}
        slotProps={{
          textField: {
            required: true,
            fullWidth: true,
            size: tidalThemeActive ? 'medium' : 'small',
            onBlur: startField.onBlur,
            error: !!startField.error,
            helperText: startField.error,
            inputProps: {
              'data-test-id': 'filters-startDate',
            },
          },
        }}
      />

      <Box sx={{ mx: 1 }} />

      <DatePicker
        label="To"
        disablePast
        {...endField}
        format={getFormat()}
        slotProps={{
          textField: {
            required: true,
            fullWidth: true,
            size: tidalThemeActive ? 'medium' : 'small',
            error: !!endField.error,
            helperText: endField.error,
            inputProps: {
              'data-test-id': 'filters-endDate',
            },
          },
        }}
      />
    </Box>
  )
}
